import uniqid from "uniqid";
import { projects, mobileAPPs } from "../../portfolio";
import ProjectContainer from "../ProjectContainer/ProjectContainer";
import "./Projects.css";

const Projects = () => {
  if (!projects.length) return null;

  return (
    <section id="projects" className="section projects">
      <h2 className="section__title reveal">
        Projects
        {/* <h5 className='reveal'>Projects I have created till now</h5> */}
      </h2>
    {/* <section id="projects" className="MobileAPP"> */}
      <h3 className="section__title reveal">
        Mobile Apps
        {/* <h5 className='reveal'>Projects I have created till now</h5> */}
      </h3>

      <div className="projects__grid">
        {mobileAPPs.map((project) => (
          <ProjectContainer key={uniqid()} project={project} />
        ))}
        </div>
        {/* </section> */}
      <br />
      <br />

      <h3 className="section__title reveal">
        Web Apps
        {/* <h5 className='reveal'>Projects I have created till now</h5> */}
      </h3>

      <div className="projects__grid">
        {projects.map((project) => (
          <ProjectContainer key={uniqid()} project={project} />
        ))}
      </div>
    </section>
  );
};

export default Projects;
